<template>
  <PublicInfoPageLayout
    eyebrow="Support"
    title="Support for Star Group"
    subtitle="Help for venue managers, staff members, and invited Friends of House users using the Star Group app at participating bars."
  >
    <template #actions>
      <v-btn color="primary" href="mailto:peter.bjerregaard@gmail.com">
        Email support
      </v-btn>
      <v-btn variant="outlined" to="/privacy">
        View privacy policy
      </v-btn>
    </template>

    <div class="support-grid">
      <section class="support-section">
        <h2>Contact</h2>
        <p>
          Developer support is provided by an independent developer for participating bars and for the managers, staff members,
          and invited Friends of House users who use Star Group.
        </p>
        <ul>
          <li><strong>App:</strong> Star Group</li>
          <li><strong>Support email:</strong> <a href="mailto:peter.bjerregaard@gmail.com">peter.bjerregaard@gmail.com</a></li>
          <li><strong>Website:</strong> <a href="https://www.star-group.dk" target="_blank" rel="noopener">www.star-group.dk</a></li>
        </ul>
      </section>

      <section class="support-section">
        <h2>Best way to get help</h2>
        <ul>
          <li>For login, account access, team setup, or role changes, contact the bar owner or venue manager responsible for the account first.</li>
          <li>For technical issues in the app, managers, staff members, and invited Friends of House users can email support with the name of the bar, device model, and screenshots if possible.</li>
          <li>For Friends of House access questions, the participating venue decides who can receive access and benefits.</li>
        </ul>
      </section>

      <section class="support-section">
        <h2>What to include in a support request</h2>
        <ul>
          <li>Your name and the bar or participating venue connected to your account</li>
          <li>Whether you are a venue manager, staff member, or invited Friends of House user</li>
          <li>The iPhone model and iOS version you are using</li>
          <li>A short description of the problem and when it happened</li>
          <li>Screenshots, if relevant</li>
        </ul>
      </section>

      <section class="support-section">
        <h2>Account management</h2>
        <p>
          Star Group accounts for managers, staff members, and invited Friends of House users are created and managed by participating bar
          owners or venue managers. You can request deletion of your own account from the profile area in the app or web service.
          If you need access changed or corrected, contact the venue managing your account or email support.
        </p>
      </section>
    </div>
  </PublicInfoPageLayout>
</template>

<script setup>
import PublicInfoPageLayout from '@/components/PublicInfoPageLayout.vue';
</script>

<style scoped>
.support-grid {
  display: grid;
  gap: 18px;
}

.support-section {
  padding: 22px 24px;
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 20px;
  background: rgba(248, 250, 252, 0.84);
}

.support-section h2 {
  margin: 0 0 10px;
  color: #101828;
  font-size: 1.1rem;
}

.support-section p,
.support-section li {
  color: #475467;
  line-height: 1.7;
}

.support-section ul {
  padding-left: 18px;
  margin: 0;
}

.support-section a {
  color: #1d4ed8;
}

@media (max-width: 600px) {
  .support-section {
    padding: 18px;
  }
}
</style>
